export default function($) {
  const latestPostsSwiper = new Swiper('.js-slider-latest-posts', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: false,
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        loop: true,
        spaceBetween: 30,
        centeredSlides: true,
      },
      1280: {
        slidesPerView: 3,
        loop: false,
        spaceBetween: 40,
        centeredSlides: false,
      }
    }
  });

  const homePostsSwiper = new Swiper('.js-slider-home-posts', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: false,
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        spaceBetween: 30,
      },
      1280: {
        slidesPerView: 4,
      }
    }
  });

  const wantedCategoriesSwiper = new Swiper('.js-slider-wanted_categories', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 40,
      }
    }
  });
}
